import React, { useEffect, useState } from "react";
import styles from "./CartTotal.module.css";

import { Typography, Grid, Paper } from "@material-ui/core";
import { useSelector } from "react-redux";
import toVND from "shared/func/toVND";

const CartTotal = () => {
  const [total, setTotal] = useState(0);
  const carts = useSelector((state) => state.carts.listInLocalStorage);
  const feeShip = useSelector((state) => state.payments.feeShip);

  useEffect(() => {
    let sum = 0;
    carts.forEach((item) => {
      sum += item.priceDiscount * item.count;
    });
    setTotal(sum);
  }, [carts]);

  return (
    <div className={styles.container}>
      <Paper variant="outlined">
        <Typography variant="h6" gutterBottom className={styles.title}>
          TỔNG ĐƠN HÀNG
        </Typography>
        {/* <Divider /> */}
        <div className={styles.content_container}>
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <Typography variant="subtitle2" gutterBottom>
                Tạm Tính:
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <h3 className={`${styles.relative_price} ${styles.price_item}`}>
                {toVND(total)}
              </h3>
            </Grid>
          </Grid>

          <Grid container spacing={3}>
            <Grid item xs={4}>
              <Typography variant="subtitle2" gutterBottom>
                Thành Tiền:
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <h2 className={`${styles.absolute_price} ${styles.price_item}`}>
                {toVND(total)}
              </h2>
            </Grid>
          </Grid>
          {feeShip.fee && (
            <div>
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  <Typography variant="subtitle2" gutterBottom>
                    Phí Ship:
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <h3
                    className={`${styles.relative_price} ${styles.price_item}`}
                  >
                    {toVND(feeShip.fee)}
                  </h3>
                  <p className={styles.information_sub}>
                    ({feeShip.delivery.name} nhận hàng)
                  </p>
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={4}>
                  <Typography variant="subtitle2" gutterBottom>
                    TỔNG TIỀN:
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <h2 className={`${styles.total_price} ${styles.price_item}`}>
                    {toVND(total + feeShip.fee)}
                  </h2>

                  <p className={styles.information_sub}>
                    Lưu ý: Kiểm tra đơn hàng trước khi nhận.
                  </p>
                </Grid>
              </Grid>
            </div>
          )}
        </div>
      </Paper>
    </div>
  );
};

export default CartTotal;
